module.exports = __webpack_public_path__ + "img/deck_builder.d5f23f53.jpg";